export const host = "https://balazstudio.com/";
export const appHost = "https://balazstudio.com/api/public/";

const apiHost = `${host}/api`;

export default apiHost;
